var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('ranking')}}),_c('v-container',[_c('meter-rankings-table-card',{attrs:{"site-meter-rankings":_vm.rankings,"loading":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }